import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import ErrorPage from './ErrorPage.js';
import Surprise from './Surprise.js';

/**
 * Errore generico.
 */
function UnexpectedErrorPage({ asPage = true }) {
    return (jsx(ErrorPage, { image: jsx(Surprise, { className: "error-page__image" }), title: "Ops... \u00E8 successo un imprevisto.", message: (jsxs(Fragment, { children: ["A volte basta ricaricare la pagina.", jsx("br", {}), "Se invece continui a vedere questo messaggio invia un quesito all'assistenza."] })), asPage: asPage }));
}

export { UnexpectedErrorPage as default };
